<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Refusjon</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>BankAxept</td>
        <td>{{ transactionsReport.refundedBankAxeptCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(transactionsReport.refundedBankAxeptPaymentsTotalAmount) }}</td>
      </tr>
      <tr>
        <td>Visa/Mastercard/Andre</td>
        <td>{{ transactionsReport.refundedNonBankAxeptCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(transactionsReport.refundedNonBankAxeptPaymentsTotalAmount) }}</td>
      </tr>
      <tr class="bold">
        <td>Total tilbakebetalt</td>
        <td>{{ refundedCardTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(refundedCardPaymentsTotalAmount) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      transactionsReport: Object
    },
    computed: {
      refundedCardTotalCount() {
        let refundedBankAxeptCount = this.transactionsReport.refundedBankAxeptCount;
        let refundedNonBankAxeptCount = this.transactionsReport.refundedNonBankAxeptCount;
        return (refundedBankAxeptCount + refundedNonBankAxeptCount);
      },

      refundedCardPaymentsTotalAmount() {
        return this.transactionsReport.refundedBankAxeptPaymentsTotalAmount + this.transactionsReport.refundedNonBankAxeptPaymentsTotalAmount;
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
